import React from 'react';
import ListItem from './ListItem';
import { Container, UList, AddSubtask } from './styles';

const Subtasks = ({
  subtasks,
  addSubtask,
  updateSubtask,
  deleteSubtask,
  current,
  setCurrent,
  status,
}) => {
  const addMoreStyle = {
    fontFamily: 'Sora',
    fontSize: '0.9rem',
    fontWeight: '500',
  };

  return (
    <Container>
      <UList len={subtasks.length} >
        {subtasks.length === 0 && status !== 'done' ? (
          <span style={addMoreStyle}>Adicione novas Subtarefas!</span>
        ) : subtasks.length === 0 && status === 'done' ? (
          <span style={addMoreStyle}>Tarefa concluida sem subtarefas</span>
        ):
         (
          subtasks.map((item, i) => (
            <ListItem
              key={i}
              item={item}
              current={current}
              setCurrent={setCurrent}
              updateSubtask={updateSubtask}
              deleteSubtask={deleteSubtask}
              status={status}
            />
          ))
        )}
      </UList>

      {status !== 'done' ? (
        <AddSubtask onClick={addSubtask}>
          <p>+ Adicionar Subtarefa</p>
        </AddSubtask>
      ) : null}
    </Container>
  );
};

export default Subtasks;
